import React from 'react';
import { gtmEventPush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import screens from '../../refresh/constants/pageType.constant';

export class FacebookLoginButton extends React.Component {
  componentDidMount() {
    document.addEventListener('FBObjectReady', this.initializeFacebookLogin);
  }

  componentWillUnmount() {
    document.removeEventListener('FBObjectReady', this.initializeFacebookLogin);
  }

  initializeFacebookLogin = () => {
    this.FB = window.FB;
  };

  constructor(props) {
    super(props);
    this.FB = window.FB;
  }

  facebookLogin = () => {
    const { login_signup: { pageType = '', pageName = '' } = {} } = screens;

    segmentEventPush({
      event:'Social Login Clicked',
      channel_used : 'facebook',
      screen_name: 'login/signup screen'
    });

    gtmEventPush({
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'facebook',
      label: 'Started',
      page_type: pageType,
      page_name: pageName
    });
    if (!this.FB) return;
    this.FB.getLoginStatus(response => {
      if (response.status === 'connected') {
        this.facebookLoginHandler(response);
      } else {
        this.FB.login(this.facebookLoginHandler, { scope: 'email' });
      }
    });
  };

  facebookLoginHandler = response => {
    if (response.status === 'connected') {
      this.FB.api('/me', { fields: 'name, email' }, userData => {
        let result = {
          ...response,
          user: userData
        };
        this.props.onLogin(true, result);
      });
    } else {
      this.props.onLogin(false);
      gtmEventPush({
        event: 'error',
        login_method: `facebook`,
        screen_type: 'login/signup screen',
        error_message: response?.status,
        page_type: 'login page'
      });
    }
  };

  render() {
    let { children } = this.props;
    return (
      <div onClick={this.facebookLogin} className="fb-login" tabIndex={0} role="button">
        {children}
      </div>
    );
  }
}
